// extracted by mini-css-extract-plugin
export var wwb = "wwb--wwb--xofni";
export var wwb__img = "wwb--wwb__img--1Ipu5";
export var wwb__wrapper = "wwb--wwb__wrapper--1TfLL";
export var wwb__container = "wwb--wwb__container--1fusV";
export var listWrapper = "wwb--list-wrapper--3KxTO";